import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CustomerSearchProfileMini } from '@shared/models/data/CustomerSearchProfileMini';
import { Constants } from '@shared/services/constants/constants';

@Component({
  selector: 'app-terms-of-service',
  templateUrl: './terms-of-service.component.html',
  styleUrls: ['./terms-of-service.component.scss']
})
export class TermsOfServiceComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<TermsOfServiceComponent>) {
    // dialogRef.addPanelClass('amp-dialog-double');
  }

  ngOnInit() {
  }

}
